var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer5Day(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3000 844",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer-5",
    serifId: "layer 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2868.13,75.631c-0.318,-1.179 -1.387,-1.998 -2.608,-1.998c-1.221,0 -2.29,0.819 -2.608,1.998c-5.24,19.068 -16.549,62.72 -16.549,84.282c-0,17.42 8.584,31.562 19.157,31.562c10.573,0 19.157,-14.142 19.157,-31.562c0,-21.562 -11.309,-65.214 -16.549,-84.282Z",
    style: {
      fill: "#a2e4b2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2837.22,60.637c-0.387,-1.255 -1.547,-2.111 -2.861,-2.111c-1.313,-0.001 -2.473,0.855 -2.861,2.11c-6.411,20.489 -21.371,70.937 -21.371,95.574c0,19.464 10.858,35.265 24.232,35.265c13.374,0 24.232,-15.801 24.232,-35.265c0,-24.637 -14.96,-75.085 -21.371,-95.573Z",
    style: {
      fill: "#a2e4b2"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2711.78,146.594c-0,-1.745 -1.414,-3.159 -3.158,-3.159l-0.001,0c-1.744,0 -3.158,1.414 -3.158,3.159c-0,12.258 -0,56.008 -0,56.008l6.317,0c-0,0 -0,-43.75 -0,-56.008Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2711.78,146.594c-0,-1.745 -1.414,-3.159 -3.158,-3.159l-0.001,0c-1.744,0 -3.158,1.414 -3.158,3.159c-0,12.258 -0,56.008 -0,56.008l6.317,0c-0,0 -0,-43.75 -0,-56.008Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2705.46,
    y: 137.118,
    width: 6.317,
    height: 15.794,
    style: {
      fill: "#06dbff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2746.44,146.203l19.588,-43.432l56.699,43.64l-0.473,48.941l-75.77,-0l-0.044,-49.149Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2746.44,146.203l19.588,-43.432l56.699,43.64l-0.473,48.941l-75.77,-0l-0.044,-49.149Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2749.85,147.254c0,-0.182 0.035,-0.363 0.104,-0.531c1.35,-3.317 15.397,-37.826 15.397,-37.826c0,0 13.671,34.548 14.97,37.831c0.065,0.165 0.099,0.341 0.099,0.519c-0,3.2 -0,34.05 -0,41.052c-0,0.778 -0.631,1.409 -1.409,1.409c-5.111,0 -22.641,0 -27.752,0c-0.778,0 -1.409,-0.631 -1.409,-1.409c0,-6.997 0,-37.806 0,-41.045Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.86
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2766.12,122.207c-0.141,-0.425 -0.539,-0.712 -0.987,-0.712c-0.448,0 -0.846,0.287 -0.988,0.712c-1.339,4.018 -3.708,11.124 -4.955,14.867c-0.191,0.572 -0.095,1.2 0.257,1.688c0.352,0.489 0.918,0.778 1.52,0.778c2.396,0 5.935,0 8.332,0c0.602,0 1.168,-0.289 1.52,-0.778c0.352,-0.488 0.448,-1.116 0.257,-1.688c-1.248,-3.743 -3.616,-10.849 -4.956,-14.867Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2763.88,95.18c-0.749,0.003 -1.426,0.444 -1.731,1.128c-2.841,6.366 -16.939,37.961 -21.161,47.422c-0.263,0.589 -0.21,1.272 0.142,1.813c0.351,0.541 0.952,0.868 1.598,0.868c0.912,0 1.869,0 2.598,0c0.752,0 1.433,-0.442 1.74,-1.129c3.054,-6.845 18.969,-42.511 18.969,-42.511c0,-0 14.892,33.373 18.63,41.75c0.513,1.15 1.654,1.89 2.913,1.89c6.716,0 28.032,0 37.752,0c1.081,0 2.088,-0.547 2.676,-1.453c0.588,-0.907 0.677,-2.049 0.237,-3.036c-4.799,-10.755 -16.8,-37.649 -20.092,-45.028c-0.515,-1.154 -1.663,-1.895 -2.926,-1.89c-7.801,0.033 -35.198,0.149 -41.345,0.176Z",
    style: {
      fill: "#70cca7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2775.61,78.953c0.644,1.078 1.808,1.739 3.065,1.739c1.256,-0 2.42,-0.661 3.065,-1.739c5.196,-8.293 15.178,-25.338 15.178,-33.92c-0,-9.701 -8.175,-17.578 -18.243,-17.578c-10.069,0 -18.244,7.877 -18.244,17.578c0,8.582 9.982,25.627 15.179,33.92Z",
    style: {
      fill: "#70cca7"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2775.61,78.953c0.644,1.078 1.808,1.739 3.065,1.739c1.256,-0 2.42,-0.661 3.065,-1.739c5.196,-8.293 15.178,-25.338 15.178,-33.92c-0,-9.701 -8.175,-17.578 -18.243,-17.578c-10.069,0 -18.244,7.877 -18.244,17.578c0,8.582 9.982,25.627 15.179,33.92Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2770.69,40.667c-1.94,1.939 -1.94,5.083 -0,7.023c1.939,1.939 5.083,1.939 7.023,-0l3.458,-3.459c0.353,-0.353 0.924,-0.353 1.277,0c0.353,0.353 0.353,0.925 0,1.278l-2.486,2.486c1.951,1.629 4.858,1.527 6.689,-0.305c1.94,-1.94 1.94,-5.084 0,-7.023c-1.938,-1.94 -5.083,-1.94 -7.023,-0l-3.458,3.458c-0.352,0.352 -0.924,0.352 -1.277,0c-0.353,-0.353 -0.353,-0.924 -0,-1.277l2.486,-2.487c-1.951,-1.628 -4.858,-1.526 -6.689,0.306Zm7.981,-1.577c-2.66,-2.341 -6.717,-2.241 -9.259,0.299c-2.644,2.645 -2.644,6.933 0,9.578c2.542,2.54 6.599,2.64 9.259,0.299c2.66,2.341 6.717,2.241 9.258,-0.299c2.644,-2.645 2.644,-6.933 -0,-9.578c-2.541,-2.54 -6.598,-2.64 -9.258,-0.299Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "house-and-car-3",
    serifId: "house and car 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M672.843,301.217c17.949,1.85 17.042,-31.74 -4.371,-35.366c-13.731,-2.325 -13.302,5.964 -21.648,5.546c-10.702,-0.537 -4.467,-19.637 -25.473,-21.172c-23.926,-1.748 -33.239,29.115 -24.34,40.816c4.823,6.34 7.882,14.936 14.736,15.862c8.233,1.114 16.51,1.908 24.718,3.189c13.437,2.096 14.623,-11.117 36.378,-8.875Z",
    style: {
      fill: "#abe3af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.717,194.792c0,-0 1.782,-59.651 1.631,-89.548c-0.047,-9.297 -0.757,-20.67 -10.974,-25.184c-1.511,-0.668 -3.148,-1.07 -4.803,-1.088c-5.333,-0.061 -10.415,2.258 -15.815,1.891c-3.879,-0.264 -14.762,-0.187 -12.045,-7.092c2.835,-7.209 12.623,-2.752 17.929,-3.952c7.803,-1.764 12.282,-10.972 20.914,-11.113c4.448,-0.073 6.359,3.248 9.574,5.55c2.684,1.922 6.01,2.404 9.23,1.99c9.377,-1.204 16.74,-10.945 27.001,-5.763c5.076,2.563 8.143,8.14 13.062,11.098c1.591,0.957 3.393,1.319 5.217,1.481c1.773,0.157 3.548,0.169 5.325,0.245c4.147,0.179 18.179,5.277 10.508,10.737c-3.302,2.351 -8.366,2.118 -12.19,2.405c-4.199,0.315 -8.612,-0.616 -12.755,-1.164c-3.58,-0.473 -7.041,-0.69 -10.604,0.071c-12.468,2.663 -20.997,17.501 -29.699,25.187c-4.361,3.852 -3.792,25.375 -3.782,38.297c0.013,15.144 0.133,30.292 0.78,45.425c0,-0 -8.504,0.527 -8.504,0.527Zm36.978,-112.405c0.521,0.22 -3.053,3.449 -4.98,4.32c-5.833,2.635 -7.997,5.098 -12.828,10.957c-2.034,2.467 -10.44,11.425 -10.882,11.398c-0.294,-0.018 0.368,-5.697 0.393,-8.3c0.061,-6.484 -1.475,-16.985 -0.19,-18.427c1.971,-2.212 10.854,3.059 17.071,1.932c5.571,-1.01 5.159,-4.529 11.416,-1.88Z",
    style: {
      fill: "#abe3af"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.158,98.487c4.339,2.292 6.043,7.597 3.802,11.838c-2.24,4.242 -7.583,5.825 -11.922,3.532c-4.339,-2.292 -6.043,-7.597 -3.802,-11.838c2.24,-4.242 7.583,-5.825 11.922,-3.532Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.486,133.622c4.824,2.548 6.718,8.444 4.227,13.159c-2.491,4.715 -8.429,6.474 -13.252,3.926c-4.823,-2.548 -6.717,-8.445 -4.227,-13.159c2.491,-4.715 8.429,-6.474 13.252,-3.926Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.026,160.901c-0.86,1.564 -2.316,2.715 -4.037,3.192c-1.72,0.476 -3.56,0.239 -5.104,-0.659c-19.848,-11.553 -83.545,-48.63 -89.083,-51.854c-0.257,-0.149 -0.51,-0.305 -0.758,-0.467c-1.233,-0.806 -5.32,-3.474 -9.205,-6.011c-1.754,-1.146 -2.803,-3.106 -2.784,-5.201c0.02,-2.094 1.106,-4.035 2.882,-5.147c0.001,-0 0.002,-0.001 0.003,-0.001c5.297,-3.318 11.734,-4.288 17.774,-2.679c7.668,2.042 17.67,4.707 20.668,5.505c0.589,0.157 1.195,0.232 1.804,0.223c1.774,-0.026 5.904,-0.087 10.438,-0.154c11.18,-0.164 22.21,2.583 32.008,7.97c-0,0 0,0.001 0.001,0.001c8.836,4.859 16.332,11.831 21.818,20.292c3.618,5.581 7.574,11.683 10.009,15.439c1.44,2.221 1.542,5.055 0.266,7.374c-1.841,3.347 -4.564,8.296 -6.7,12.177Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.026,160.901c-0.86,1.564 -2.316,2.715 -4.037,3.192c-1.72,0.476 -3.56,0.239 -5.104,-0.659c-19.848,-11.553 -83.545,-48.63 -89.083,-51.854c-0.257,-0.149 -0.51,-0.305 -0.758,-0.467c-1.233,-0.806 -5.32,-3.474 -9.205,-6.011c-1.754,-1.146 -2.803,-3.106 -2.784,-5.201c0.02,-2.094 1.106,-4.035 2.882,-5.147c0.001,-0 0.002,-0.001 0.003,-0.001c5.297,-3.318 11.734,-4.288 17.774,-2.679c7.668,2.042 17.67,4.707 20.668,5.505c0.589,0.157 1.195,0.232 1.804,0.223c1.774,-0.026 5.904,-0.087 10.438,-0.154c11.18,-0.164 22.21,2.583 32.008,7.97c-0,0 0,0.001 0.001,0.001c8.836,4.859 16.332,11.831 21.818,20.292c3.618,5.581 7.574,11.683 10.009,15.439c1.44,2.221 1.542,5.055 0.266,7.374c-1.841,3.347 -4.564,8.296 -6.7,12.177Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.681,143.576c4.859,4.745 5.038,12.454 0.399,17.203c-4.638,4.749 -12.349,4.752 -17.208,0.007c-4.858,-4.745 -5.037,-12.454 -0.399,-17.203c4.639,-4.749 12.349,-4.752 17.208,-0.007Z",
    style: {
      fill: "#ffbd58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.159,109.6c4.859,4.746 5.038,12.454 0.399,17.203c-4.638,4.75 -12.349,4.753 -17.207,0.008c-4.859,-4.746 -5.038,-12.454 -0.399,-17.203c4.638,-4.75 12.349,-4.753 17.207,-0.008Z",
    style: {
      fill: "#ffbd58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.659,98.609c-0.126,0.139 -0.188,0.324 -0.17,0.51c0.017,0.186 0.111,0.357 0.261,0.47c1.58,1.199 6.035,4.579 8.886,6.742c1.547,1.173 3.619,1.383 5.369,0.543c1.668,-0.801 3.819,-1.834 5.748,-2.76c3.186,-1.529 6.717,-2.198 10.241,-1.939c1.778,0.131 3.799,0.28 5.739,0.422c0.57,0.042 1.084,-0.342 1.205,-0.901c0.12,-0.559 -0.19,-1.122 -0.727,-1.318c-0.324,-0.119 -0.571,-0.209 -0.71,-0.26c-0.084,-0.031 -0.171,-0.058 -0.258,-0.081c-1.37,-0.357 -13.184,-3.436 -21.523,-5.61c-5.099,-1.329 -10.515,0.282 -14.059,4.181c-0.001,0 -0.001,0.001 -0.002,0.001Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.86
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.347,107.829c-0.149,-0.086 -0.235,-0.25 -0.221,-0.421c0.013,-0.172 0.124,-0.32 0.285,-0.381c0.772,-0.295 1.992,-0.76 3.416,-1.303c7.479,-2.851 15.893,-1.72 22.353,3.005c0,0 0.001,0.001 0.001,0.001c6.091,4.455 11.446,9.839 15.868,15.955c0.804,1.111 1.623,2.245 2.424,3.353c0.654,0.904 0.587,2.142 -0.16,2.971c-0.748,0.829 -1.973,1.023 -2.94,0.466c-13.344,-7.691 -36.421,-20.992 -41.026,-23.646Z",
    style: {
      fill: "#70cca7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.366,101.812c0.269,-0.09 0.445,-0.349 0.43,-0.632c-0.015,-0.283 -0.217,-0.522 -0.494,-0.583c-6.234,-1.319 -13.073,-1.658 -18.483,-0.732c-0.25,0.048 -0.447,0.243 -0.498,0.492c-0.05,0.25 0.054,0.506 0.265,0.648c1.999,1.351 5.788,3.909 6.81,4.599c0.164,0.11 0.369,0.138 0.556,0.075c1.465,-0.497 8,-2.71 11.414,-3.867Z",
    style: {
      fill: "#70cca7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.268,109.663c4.823,2.548 6.717,8.444 4.226,13.159c-2.49,4.715 -8.428,6.474 -13.252,3.926c-4.823,-2.548 -6.717,-8.444 -4.226,-13.159c2.49,-4.715 8.428,-6.474 13.252,-3.926Z",
    style: {
      fill: "#70cca7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.789,143.639c4.824,2.548 6.718,8.444 4.227,13.159c-2.491,4.714 -8.429,6.473 -13.252,3.925c-4.823,-2.548 -6.717,-8.444 -4.226,-13.159c2.49,-4.714 8.428,-6.473 13.251,-3.925Z",
    style: {
      fill: "#70cca7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M607.545,116.945l-19.204,-31.894l-53.918,32.124l2.536,170.296l72.628,-0l-2.042,-170.526Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M607.545,116.945l-19.204,-31.894l-53.918,32.124l2.536,170.296l72.628,-0l-2.042,-170.526Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.695,247.323c0,-4.603 -3.731,-8.334 -8.333,-8.334c-0,0 -0,0 -0,0c-4.602,0 -8.333,3.731 -8.333,8.334c-0,12.05 -0,32.913 -0,32.913l16.666,-0l0,-32.913Z",
    style: {
      fill: "#70cca7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M590.303,85.173c1.167,0.003 2.249,0.608 2.863,1.6c3.426,5.533 14.826,23.946 19.196,31.006c0.358,0.577 0.381,1.301 0.061,1.9c-0.319,0.599 -0.933,0.982 -1.612,1.007c-0.791,0.028 -1.582,0.056 -2.188,0.078c-0.669,0.024 -1.302,-0.305 -1.666,-0.867c-3.163,-4.875 -18.023,-27.781 -18.023,-27.781c0,-0 -13.926,21.228 -17.721,27.012c-0.589,0.898 -1.592,1.44 -2.666,1.44c-5.916,-0 -25.584,-0 -35.434,-0c-1.158,-0 -2.224,-0.627 -2.787,-1.638c-0.563,-1.01 -0.534,-2.247 0.075,-3.231c5.046,-8.15 14.954,-24.155 18.038,-29.136c0.583,-0.942 1.614,-1.514 2.722,-1.51c3.615,0.011 11.468,0.036 11.468,0.036c-0,-0 -0,-7.84 -0,-11.455c-0,-0.987 0.8,-1.787 1.786,-1.787c1.277,0 2.988,0 4.265,0c0.473,0 0.928,0.189 1.263,0.524c0.335,0.335 0.523,0.789 0.523,1.263c0,3.62 0,11.48 0,11.48c0,-0 14.565,0.043 19.837,0.059Z",
    style: {
      fill: "#70cca7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.111,131.868c0.022,-0.951 -0.341,-1.871 -1.006,-2.552c-0.666,-0.68 -1.577,-1.064 -2.529,-1.064c-6.044,0 -18.123,0 -24.112,0c-1.953,0 -3.535,1.583 -3.535,3.536c-0,8.789 -0,31.273 -0,36.148c-0,0.617 0.161,1.224 0.468,1.759c2.531,4.414 14.74,25.709 22.4,39.07c0.79,1.377 2.4,2.059 3.938,1.668c1.538,-0.391 2.628,-1.759 2.664,-3.346c0.482,-21.207 1.428,-62.758 1.712,-75.219Z",
    style: {
      fill: "#fff8f5",
      fillOpacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.977,157.711c-0,-0.866 -0.344,-1.697 -0.957,-2.31c-0.613,-0.612 -1.443,-0.956 -2.31,-0.956c-0.002,-0 -0.004,-0 -0.006,-0c-0.867,-0 -1.698,0.344 -2.31,0.956c-0.613,0.613 -0.957,1.444 -0.957,2.31c0,12.686 0,57.984 0,57.984l6.54,-0c-0,-0 -0,-45.298 -0,-57.984Z",
    style: {
      fill: "#383128"
    }
  }), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.977,157.711c-0,-0.866 -0.344,-1.697 -0.957,-2.31c-0.613,-0.612 -1.443,-0.956 -2.31,-0.956c-0.002,-0 -0.004,-0 -0.006,-0c-0.867,-0 -1.698,0.344 -2.31,0.956c-0.613,0.613 -0.957,1.444 -0.957,2.31c0,12.686 0,57.984 0,57.984l6.54,-0c-0,-0 -0,-45.298 -0,-57.984Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.437,
    y: 147.905,
    width: 6.54,
    height: 16.35,
    style: {
      fill: "#20f58f"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M544.434,210.464l-22.838,-43.432l-66.102,43.64l0.552,69.564l88.336,-0l0.052,-69.772Z",
    style: {
      fill: "#ffebba"
    }
  }), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.434,210.464l-22.838,-43.432l-66.102,43.64l0.552,69.564l88.336,-0l0.052,-69.772Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M498.15,218.79c-0,-0.778 -0.631,-1.409 -1.409,-1.409c-5.712,0 -27.11,0 -32.821,0c-0.779,0 -1.409,0.631 -1.409,1.409c-0,6.266 -0,31.564 -0,37.829c-0,0.779 0.63,1.409 1.409,1.409c5.711,0 27.109,0 32.821,0c0.778,0 1.409,-0.63 1.409,-1.409c0,-6.265 0,-31.563 0,-37.829Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M519.905,186.002c0.156,-0.4 0.541,-0.664 0.971,-0.664c0.429,0 0.814,0.264 0.97,0.664c1.509,3.883 4.403,11.33 5.925,15.247c0.224,0.576 0.149,1.226 -0.2,1.737c-0.349,0.51 -0.928,0.815 -1.546,0.815c-2.888,0 -7.411,0 -10.299,0c-0.618,0 -1.197,-0.305 -1.546,-0.815c-0.349,-0.511 -0.424,-1.161 -0.2,-1.737c1.522,-3.917 4.416,-11.364 5.925,-15.247Z",
    style: {
      fill: "#ffa35f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.391,159.442c0.708,0.002 1.357,0.397 1.683,1.025c3.174,6.101 19.656,37.784 24.67,47.421c0.307,0.591 0.284,1.299 -0.062,1.868c-0.345,0.569 -0.962,0.916 -1.628,0.916c-1.268,-0 -2.653,-0 -3.599,-0c-0.71,-0 -1.362,-0.395 -1.69,-1.026c-3.424,-6.582 -22.169,-42.614 -22.169,-42.614c0,-0 -17.605,33.842 -21.809,41.922c-0.549,1.056 -1.639,1.718 -2.829,1.718c-7.344,-0 -33.638,-0 -44.967,-0c-1.115,-0 -2.148,-0.582 -2.727,-1.535c-0.578,-0.952 -0.617,-2.138 -0.103,-3.126c5.699,-10.955 19.741,-37.948 23.426,-45.03c0.551,-1.059 1.647,-1.722 2.841,-1.717c8.501,0.03 42.282,0.153 48.963,0.178Z",
    style: {
      fill: "#70cca7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M561.397,47.158c1.12,2.122 3.323,3.45 5.722,3.45c2.4,0 4.602,-1.327 5.722,-3.449c5.349,-8.952 12.521,-22.307 12.521,-29.581c-0,-9.702 -8.175,-17.578 -18.243,-17.578c-10.069,0 -18.244,7.876 -18.244,17.578c0,7.274 7.172,20.629 12.522,29.58Z",
    style: {
      fill: "#70cca7"
    }
  }), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.397,47.158c1.12,2.122 3.323,3.45 5.722,3.45c2.4,0 4.602,-1.327 5.722,-3.449c5.349,-8.952 12.521,-22.307 12.521,-29.581c-0,-9.702 -8.175,-17.578 -18.243,-17.578c-10.069,0 -18.244,7.876 -18.244,17.578c0,7.274 7.172,20.629 12.522,29.58Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.138,13.212c-1.94,1.938 -1.94,5.083 -0,7.023c1.94,1.939 5.083,1.939 7.023,-0l3.458,-3.459c0.354,-0.353 0.925,-0.353 1.278,0c0.352,0.353 0.352,0.924 -0,1.278l-2.487,2.486c1.951,1.628 4.858,1.526 6.69,-0.305c1.939,-1.94 1.939,-5.085 -0,-7.023c-1.939,-1.94 -5.084,-1.94 -7.024,-0l-3.458,3.458c-0.352,0.352 -0.924,0.352 -1.277,0c-0.353,-0.353 -0.353,-0.924 -0,-1.277l2.486,-2.487c-1.951,-1.628 -4.858,-1.526 -6.689,0.306Zm7.981,-1.578c-2.66,-2.34 -6.717,-2.24 -9.258,0.3c-2.645,2.645 -2.645,6.933 -0,9.578c2.541,2.54 6.598,2.64 9.258,0.299c2.66,2.341 6.717,2.241 9.258,-0.299c2.644,-2.645 2.644,-6.933 -0,-9.578c-2.541,-2.54 -6.598,-2.64 -9.258,-0.3Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "mountains-4",
    serifId: "mountains 4",
    d: "M3000,27.455c-0,0 -130.175,159.923 -305.655,163.501c-156.279,3.188 -277.006,-214.32 -427.679,-142.668c-113.336,53.897 -224.977,337.066 -462.502,342.392c-239.458,5.369 -475.017,-237.968 -667.708,-217.39c-152.636,16.301 -221.416,147.66 -482.29,118.486c-228.635,-25.569 -467.948,-300.944 -654.166,-258.888l0,810.965l3000,0l-0,-816.398Z",
    style: {
      fill: "url(#_Linear9)",
      fillRule: "nonzero"
    }
  }), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3000,27.455c-0,0 -130.175,159.923 -305.655,163.501c-156.279,3.188 -277.006,-214.32 -427.679,-142.668c-113.336,53.897 -224.977,337.066 -462.502,342.392c-239.458,5.369 -475.017,-237.968 -667.708,-217.39c-152.636,16.301 -221.416,147.66 -482.29,118.486c-228.635,-25.569 -467.948,-300.944 -654.166,-258.888l0,810.965l3000,0l-0,-816.398Z",
    clipRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2749.72,182.858c6.25,-1.991 9.609,-1.938 0.153,1.792c-28.132,11.096 -71.762,30.409 -54.624,39.868c19.61,10.824 33.91,27.321 0.606,40.244c-27.268,10.58 -72.678,-0.687 -108.196,16.551c-22.542,10.941 31.136,24.929 19.451,47.075c-11.369,21.548 -85.396,61.776 -126.052,72.168l-78.976,-15.174c85.001,-18.13 152.239,-38.382 170.476,-58.245c18.379,-20.019 -49.956,-37.528 1.997,-60.423c34.115,-15.034 88.944,1.368 119.641,-18.701c7.405,-4.841 -5.808,-13.146 -13.288,-19.328c-21.804,-18.023 31.53,-33.945 68.812,-45.827Z",
    style: {
      fill: "#ffeda1",
      fillOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.131,283.129c5.299,-1.25 13.002,2.147 4.886,4.087c-22.736,5.437 -53.258,18.086 -41.104,27.935c11.617,9.413 28.338,19.317 10.097,27.163c-22.077,9.495 -52.596,10.352 -78.068,29.595c-16.167,12.213 19.4,25.337 14.1,41.147c-5.157,15.383 -61.609,42.964 -92.512,59.616l-66.642,12.003c65.283,-32.747 115.818,-49.552 126.838,-65.769c11.106,-16.344 -36.96,-33.478 -9.684,-54.041c24.254,-18.285 84.542,-25.025 86.912,-33.836c2.752,-10.229 -7.119,-10.687 -8.099,-18.049c-2.39,-17.968 35.793,-25.726 53.276,-29.851Z",
    style: {
      fill: "#ffeda1",
      fillOpacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-27.0833,-1054.17,1054.17,-27.0833,1706.25,1081.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fdda97",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#e1dfa3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9cedc2",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer5Day);
export default __webpack_public_path__ + "static/media/layer5-day.a18dcacf02a4faa08489529033cc4741.svg";
export { ForwardRef as ReactComponent };